import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "country-dashboards-ves" }
const _hoisted_2 = { class: "country-dashboards-ves__body container-page big export-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountryDashboardsFilterBlock = _resolveComponent("CountryDashboardsFilterBlock")!
  const _component_DateActualDataSubtitle = _resolveComponent("DateActualDataSubtitle")!
  const _component_CountryDashboardsIndicatorCards = _resolveComponent("CountryDashboardsIndicatorCards")!
  const _component_CountryDashboardsPersonCards = _resolveComponent("CountryDashboardsPersonCards")!
  const _component_CountryDashboardsTopRfSubjectsGrowthRateCharts = _resolveComponent("CountryDashboardsTopRfSubjectsGrowthRateCharts")!
  const _component_CountryDashboardsChartsBlock = _resolveComponent("CountryDashboardsChartsBlock")!
  const _component_DashboardsTables = _resolveComponent("DashboardsTables")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CountryDashboardsFilterBlock, {
        onChangeFilter: _ctx.changeFilter,
        filter: _ctx.filter,
        plannedEventsRegionRfIds: _ctx.getPlannedEventsRegionRfIds
      }, null, 8, ["onChangeFilter", "filter", "plannedEventsRegionRfIds"]),
      _createVNode(_component_DateActualDataSubtitle, {
        class: "country-dashboards-ves__subtitle",
        filter: _ctx.filter,
        isSimpleYearLabel: ""
      }, null, 8, ["filter"]),
      _createVNode(_component_CountryDashboardsIndicatorCards, { filter: _ctx.filter }, null, 8, ["filter"]),
      _createVNode(_component_CountryDashboardsPersonCards, { filter: _ctx.filter }, null, 8, ["filter"]),
      _withDirectives(_createVNode(_component_CountryDashboardsTopRfSubjectsGrowthRateCharts, { filter: _ctx.filter }, null, 8, ["filter"]), [
        [_vShow, _ctx.isGrowthRateVisible]
      ]),
      _createVNode(_component_CountryDashboardsChartsBlock, { filter: _ctx.filter }, null, 8, ["filter"]),
      _createVNode(_component_DashboardsTables, {
        params: _ctx.tableFilter,
        hideCountryFilter: "",
        class: "country-dashboards-ves__tables",
        onChangePlannedEventsFilter: _ctx.changePlannedEventsFilter
      }, null, 8, ["params", "onChangePlannedEventsFilter"])
    ])
  ]))
}